/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sgrp_ReasoningInputs */

const en_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const ar_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستدلال`)
};

const bn_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিজনিং`)
};

const de_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const es_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const fr_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const pt_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const zh_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const tr_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const ru_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

const pl_sgrp_reasoning = /** @type {(inputs: Sgrp_ReasoningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REASONING`)
};

/**
* | output |
* | --- |
* | "REASONING" |
*
* @param {Sgrp_ReasoningInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const sgrp_reasoning = /** @type {((inputs?: Sgrp_ReasoningInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sgrp_ReasoningInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_sgrp_reasoning(inputs)
	if (locale === "bn") return bn_sgrp_reasoning(inputs)
	if (locale === "de") return de_sgrp_reasoning(inputs)
	if (locale === "es") return es_sgrp_reasoning(inputs)
	if (locale === "fr") return fr_sgrp_reasoning(inputs)
	if (locale === "pt") return pt_sgrp_reasoning(inputs)
	if (locale === "zh") return zh_sgrp_reasoning(inputs)
	if (locale === "tr") return tr_sgrp_reasoning(inputs)
	if (locale === "ru") return ru_sgrp_reasoning(inputs)
	if (locale === "pl") return pl_sgrp_reasoning(inputs)
	return en_sgrp_reasoning(inputs)
});